import React from 'react';
import {z} from 'zod';

import {Interests} from '@mui/icons-material';

import {Social,SocialPropsSchema} from './Social';
import SocialSidebarPanel from './SocialSidebarPanel';

export type SocialProps = z.infer<typeof SocialPropsSchema>;

export default {
    label: 'Social Icons',
    icon: <Interests />,
    type: 'Social',
    defaultData: {
        props: {
            facebookUrl: 'globalState',
            instagramUrl: 'globalState',
            youtubeUrl: 'globalState',
            tiktokUrl: 'globalState',
            linkedinUrl: 'globalState',
            xUrl: 'globalState',
            iconSize: 28,
            iconGap: 12,
            //Set to 0 for auto, otherwise a number used as percentage
            tableWidth: 0,
        },
        style: {
            width: 'auto',
            textAlign: 'center',
            padding: { top: 16, bottom: 16, left: 24, right: 24 },
        },
    },
    SidebarPanel: SocialSidebarPanel,
    Component: Social,
    schema: SocialPropsSchema,
};